import React from "react";
import { NOOP } from "@fedsim/helpers";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import Avatar from "@mui/icons-material/AccountBox";
import List from "@mui/icons-material/FormatAlignCenter";
import Card from "@mui/icons-material/ViewCarousel";

export default function ToggleButtons({ value = "", onChange = NOOP }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      aria-label="list type"
      size="small"
    >
      <ToggleButton value="avatar" aria-label="avatar">
        <Avatar />
      </ToggleButton>
      <ToggleButton value="card" aria-label="card">
        <Card />
      </ToggleButton>
      <ToggleButton value="list" aria-label="list">
        <List />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
